export class RegistrationSource {
  constructor(data) {
    this.id = data.id;
    this.name = data.name;
  }
}
